<script>
import vmware_requestService from '@/api-services/vmware_request.service'

let next_id = 0

export default {
  name: 'AccountsInput',
  components: {},
  props: {
    value: { type: Array, default: () => [''] },
    label: { type: String, default: null },
  },
  data() {
    return {
      ids: this.value.map(() => next_id++),
      validation_result: {}, // login_name -> { valid, status }
      validating: false,
      error_msg: null
    }
  },
  computed: {
    names() {
      const trimmed = this.value.map(a => a.trim()).filter(a => a.length > 0)
      return [...new Set(trimmed)]
    },
    // rein synchron, leitet nur aus den bereits vorhandenen Ergebnissen ab
    valid() {
      if (this.names.length === 0) return false
      return this.names.every(name => {
        const r = this.validation_result[name]
        return !!r && r.valid
      })
    },
  },
  watch: {
    valid: {
      immediate: true,
      handler(v) { this.$emit('validity-change', v) },
    },
    value: {
      immediate: true,
      handler(v) {
        if (v.length !== this.ids.length) this.ids = v.map(() => next_id++)
        this.schedule_validation()
      },
    },
  },
  created() {
    // bewusst nicht reaktiv
    this.timer = null
    this.request_id = 0
  },
  beforeDestroy() {
    clearTimeout(this.timer)
  },
  methods: {
    schedule_validation() {
      clearTimeout(this.timer)
      this.validating = true
      this.timer = setTimeout(() => this.validate(this.names), 400)
    },
    async validate(names) {
      const id = ++this.request_id
      try {
        const { data } = await vmware_requestService.validate_account_name(this.$store.state, names)
        if (id !== this.request_id) return
        const result = { ...this.validation_result }
        for (const r of data) {
          result[r.login_name] = { valid: r.valid, status: r.validation_result }
        }
        this.validation_result = result
      } catch (e) {
        this.error_msg = e.response.data.message + '(' + e.response.data.reason + ')'
      } finally {
        if (id === this.request_id) this.validating = false
      }
    },
    state_of(account) {
      const r = this.validation_result[account.trim()]
      if (!account.trim() || !r) return null
      return r.valid
    },
    update(index, account) {
      const copy = [...this.value]
      copy[index] = account
      this.$emit('input', copy)
    },
    add() {
      this.ids.push(next_id++)
      this.$emit('input', [...this.value, ''])
    },
    remove(index) {
      this.ids.splice(index, 1)
      this.$emit('input', this.value.filter((_, i) => i !== index))
    },
    result_of(account) {
      const name = account.trim()
      return name ? this.validation_result[name] || null : null
    },
  },
}
</script>

<template>
  <div>
    <b-form-group :label="label">
      <b-input-group v-for="(account, index) in value" :key="ids[index]" class="mt-2">
        <b-form-input :value="account" :state="state_of(account)" @input="update(index, $event)" />
        <b-button variant="danger" :disabled="value.length === 1" @click="remove(index)">
          <netvs-icon icon="delete" />
        </b-button>
        <b-form-invalid-feedback :state="state_of(account)">
          <span v-if="result_of(account).status === 'AccountNotFound'">{{$t('components.requests.vmware.accounts.validation_result.no_account')}}</span>
          <span v-if="result_of(account).status === 'NoADMAccount'">{{$t('components.requests.vmware.accounts.validation_result.no_adm_account')}}</span>
          <span v-else>Unknown error: {{result_of(account.status)}}</span>
        </b-form-invalid-feedback>
      </b-input-group>
    </b-form-group>
    <b-button v-if="validating" variant="link" disabled>
      <b-spinner small /> {{$t('components.requests.vmware.accounts.validating')}}
    </b-button>
    <b-alert variant="danger" show v-if="error_msg != null">
      <netvs-icon icon="warning" />
      {{error_msg}}
    </b-alert>
    <b-button variant="outline-success" class="w-100" @click="add">
      <netvs-icon icon="add_item" />
    </b-button>
  </div>
</template>
